import React, {useState} from 'react';
import ActionButton from "../../components/ActionButton";
import {useExcluirConta} from "../../lib/DataHooks/excluirContaHook";
import {useAppDispatch} from "../../lib/hooks";
import {actions, resetLocalStorage} from "../../lib/app";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import {disableDeviceToken} from "../../lib/pushService";
import fb from "lib/firebase";

interface ExcluirContaButtonProps {
  mensagem: string;
}

const messageExcluir = [
  "Tem certeza que deseja excluir sua conta Virbac no Campo?",
  "Seu acesso será cancelado e seus dados serão removidos do banco de dados em algumas horas após a confirmação da sua solicitação, essa ação não pode ser facilmente revertida.",
];

const ExcluirContaButton: React.FC<ExcluirContaButtonProps> = (props) => {
  const {mensagem} = props;
  const dispatch = useAppDispatch();
  const {isLoading, excluirConta} = useExcluirConta();
  const [alertIsOpen, setAlertIsOpen] = useState(false);


  const onClickExcluir = async () => {
    try {
      await excluirConta({mensagem});
      setAlertIsOpen(false);
      dispatch(actions.notifySuccess("Solicitação de exclusão registrada com sucesso!"));

      await disableDeviceToken();
      await resetLocalStorage();
      dispatch(actions.logout());
      await fb.auth.signOut();
    } catch (error: any) {
      dispatch(actions.notifyError(error));
    }
  }

  return (
    <>
      <ActionButton
        color={'danger'}
        onClick={() => setAlertIsOpen(true)}
        loading={isLoading}
        fill={'clear'}
      >
        Excluir conta...
      </ActionButton>

      <ConfirmationAlert
        isOpen={alertIsOpen}
        onDidDismiss={() => setAlertIsOpen(false)}
        messages={messageExcluir}
        onConfirm={onClickExcluir}
        isLoading={isLoading}
      />
    </>
  );
}

export default ExcluirContaButton;
